<template>
  <v-container class="mt-4">
    <v-row align="center">
      <v-col cols="12" sm="4">
        <v-autocomplete :items="portalCustomers" item-text="customerName" item-value="customerId" v-model="customerId"
                        label="Customer" dense outlined hide-details
                        no-data-text="No portal customers created"
                        @change="$emit('input',customerId)"/>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" sm="6">

        <outlined-block title="Inventory available in portal">
          <v-tabs class="my-2">

            <v-tab>Mash Bills</v-tab>
            <v-tab-item>
              <v-simple-table fixed-header height="calc(100vh - 302px)">
                <thead>
                  <tr>
                    <th width="5%">
                      <v-menu :close-on-content-click="false" bottom right transition="slide-y-transition" nudge-bottom="35" v-model="showAddMashBill">
                        <template v-slot:activator="{on}">
                          <v-btn fab color="primary" x-small v-on="on" :disabled="!customerId || !eligibleMashBills.length"
                                @click="id=eligibleMashBills[0].id">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="pt-4 px-2" width="400">
                          <v-autocomplete label="MashBill to add" v-model="id"
                                  :items="eligibleMashBills" item-value="id" item-text="name" dense outlined hide-details/>
                          <v-divider/>
                          <v-card-actions class="pr-4">
                            <v-spacer/>
                            <v-btn plain small color="primary" @click="showAddMashBill=false">Cancel</v-btn>
                            <v-btn small color="primary" @click="addMashBill()">Add</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </th>
                    <th>Mash Bill</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(id,index) in mashBills" :key="id">
                    <td><v-btn icon @click.stop="deleteMashBill(id,index)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                    <td>{{allMashBills.find(m => m.id === id).name}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

            <v-tab>Processes</v-tab>
            <v-tab-item>
              <v-simple-table fixed-header height="calc(100vh - 302px)">
                <thead>
                  <tr>
                    <th width="5%">
                      <v-menu :close-on-content-click="false" bottom right transition="slide-y-transition" nudge-bottom="35" v-model="showAddProcess">
                        <template v-slot:activator="{on}">
                          <v-btn fab color="primary" x-small v-on="on" :disabled="!customerId || !eligibleProcesses.length"
                                @click="id=eligibleProcesses[0].id">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="pt-4 px-2" width="400">
                          <v-autocomplete label="Process to add" v-model="id"
                                  :items="eligibleProcesses" item-value="id" item-text="name" dense outlined hide-details/>
                          <v-divider/>
                          <v-card-actions class="pr-4">
                            <v-spacer/>
                            <v-btn plain small color="primary" @click="showAddProcess=false">Cancel</v-btn>
                            <v-btn small color="primary" @click="addProcess()">Add</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </th>
                    <th>Process</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(id,index) in processes" :key="id">
                    <td><v-btn icon @click.stop="deleteProcess(id,index)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                    <td>{{allProcesses.find(p => p.id === id).name}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

            <v-tab>Formulas</v-tab>
            <v-tab-item>
              <v-simple-table fixed-header height="calc(100vh - 302px)">
                <thead>
                  <tr>
                    <th width="5%">
                      <v-menu :close-on-content-click="false" bottom right transition="slide-y-transition" nudge-bottom="35" v-model="showAddFormula">
                        <template v-slot:activator="{on}">
                          <v-btn fab color="primary" x-small v-on="on" :disabled="!customerId || !eligibleFormulas.length"
                                @click="id=eligibleFormulas[0].id">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="pt-4 px-2" width="400">
                          <v-autocomplete label="Formula to add" v-model="id"
                                  :items="eligibleFormulas" item-value="id" item-text="name" dense outlined hide-details/>
                          <v-divider/>
                          <v-card-actions class="pr-4">
                            <v-spacer/>
                            <v-btn plain small color="primary" @click="showAddFormula=false">Cancel</v-btn>
                            <v-btn small color="primary" @click="addFormula()">Add</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </th>
                    <th>Formula</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(id,index) in formulas" :key="id">
                    <td><v-btn icon @click.stop="deleteFormula(id,index)"><v-icon small>mdi-delete</v-icon></v-btn></td>
                    <td>{{allFormulas.find(f => f.id === id).name}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-tab-item>

          </v-tabs>
        </outlined-block>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'AppsPortalProduction',
  props: {
    portalCustomers: {type:Array, required:true},
    value: {type:String, required:true}
  },
  data() {
    return {
      customerId: this.value,

      showAddMashBill: false,
      showAddProcess: false,
      showAddFormula: false,
      id: '',

      allMashBills: [],
      mashBills: [],

      allProcesses: [],
      processes: [],

      allFormulas: [],
      formulas: [],
    }
  },
  watch: {
    value() {
      this.customerId = this.value;
      this.getProduction();
    }
  },
  computed: {
    customer() {
      return this.portalCustomers.find(customer => customer.customerId === this.customerId) ?? {mashBills:[],processes:[],formulas:[]};
    },
    eligibleMashBills() {
      return this.allMashBills.filter(mashBill => !this.mashBills.some(id => id === mashBill.id));
    },
    eligibleProcesses() {
      return this.allProcesses.filter(process => !this.processes.some(id => id === process.id));
    },
    eligibleFormulas() {
      return this.allFormulas.filter(formula => !this.formulas.some(id => id === formula.id));
    }
  },
  async created() {
    this.$lazyListLoad(this.allMashBills, 'mashBills2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.allProcesses, 'processes2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.allFormulas, 'formulas2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    if (this.customerId)
      this.getProduction();
  },
  methods: {
    async getProduction() {
      if (!this.customer.mashBills) {
        const results = await this.$apiCall(`query AppsPortal($customerId:ID!) {
                                                portalCustomer(customerId:$customerId) {
                                                  mashBills {mashBillId}
                                                  processes {processId}
                                                  formulas {formulaId}
                                                }
                                            }`,
                                            {customerId:this.customerId}, false, 'portal');
        if (!results.error) {
          this.customer.mashBills = results.data.portalCustomer.mashBills.map(mashBill => mashBill.mashBillId);
          this.customer.processes = results.data.portalCustomer.processes.map(process => process.processId);
          this.customer.formulas = results.data.portalCustomer.formulas.map(formula => formula.formulaId);
        }
      }
      this.mashBills = this.customer.mashBills;
      this.processes = this.customer.processes;
      this.formulas = this.customer.formulas;
    },

    async addMashBill() {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $mashBillId:ID!) {
                                              portalMashBillCreate(customerId:$customerId, mashBillId:$mashBillId) {
                                                mashBillId
                                              }
                                          }`,
                                          {customerId:this.customerId,mashBillId:this.id}, false, 'portal');
      if (!results.error) {
        this.mashBills.push(this.id);
        this.showAddMashBill = false;
      }
    },
    async deleteMashBill(mashBillId, index) {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $mashBillId:ID!) {
                                              portalMashBillDelete(customerId:$customerId, mashBillId:$mashBillId) {
                                                mashBillId
                                              }
                                          }`,
                                          {customerId:this.customerId,mashBillId}, false, 'portal');
      if (!results.error)
        this.mashBills.splice(index,1);
    },

    async addProcess() {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $processId:ID!) {
                                              portalProcessCreate(customerId:$customerId, processId:$processId) {
                                                processId
                                              }
                                          }`,
                                          {customerId:this.customerId,processId:this.id}, false, 'portal');
      if (!results.error) {
        this.processes.push(this.id);
        this.showAddProcess = false;
      }
    },
    async deleteProcess(processId, index) {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $processId:ID!) {
                                              portalProcessDelete(customerId:$customerId, processId:$processId) {
                                                processId
                                              }
                                          }`,
                                          {customerId:this.customerId,processId}, false, 'portal');
      if (!results.error)
        this.processes.splice(index,1);
    },

    async addFormula() {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $formulaId:ID!) {
                                              portalFormulaCreate(customerId:$customerId, formulaId:$formulaId) {
                                                formulaId
                                              }
                                          }`,
                                          {customerId:this.customerId,formulaId:this.id}, false, 'portal');
      if (!results.error) {
        this.formulas.push(this.id);
        this.showAddFormula = false;
      }
    },
    async deleteFormula(formulaId, index) {
      const results = await this.$apiCall(`mutation AppsPortal($customerId:ID!, $formulaId:ID!) {
                                              portalFormulaDelete(customerId:$customerId, formulaId:$formulaId) {
                                                formulaId
                                              }
                                          }`,
                                          {customerId:this.customerId,formulaId}, false, 'portal');
      if (!results.error)
        this.formulas.splice(index,1);
    }
  }
}
</script>